export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal.',
		"url" : 'https://fb.watch/GLvG7qsao0/',
	},


	// {
	// 	"nombre": "Noticias.",
	// 	"imagen": 'noticias/kermes.jpg',
	//    "funcion": '“Kermés con Causa”',
	// 	"url" : 'https://www.facebook.com/share/p/1JuWn6xhWd/',
	// },

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/CA310326.jpg',
	   "funcion": 'Contraloría en Acción.',
		"url" : 'https://fb.watch/GLF3nsOSn_/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]